import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { PermitableTypes } from 'enum/permissionsTypes.enum'
import { useAccess } from 'contexts/AccessContext'
import { ICoursePermissions } from 'store/states/access.state'
import { IMainState } from 'store/states'

interface UseProfilesProps {
  coursePermission?: ICoursePermissions
}

export const useProfiles = ({ coursePermission }: UseProfilesProps) => {
  const access = useAccess()
  const { allProfilesList: lmsProfileList } = useSelector(
    ({ lmsProfiles }: IMainState) => lmsProfiles
  )

  const hasProfilesLimited =
    access.roles.moderator &&
    (!coursePermission ||
      coursePermission.permissionType === PermitableTypes.LmsProfile)

  const profiles = useMemo(() => {
    if (hasProfilesLimited)
      return access.lmsProfiles
        .filter(({ canManageCourses }) => canManageCourses)
        .map(({ profile }) => ({
          value: profile.id,
          label: profile.name,
          color: profile.color,
        }))
    return lmsProfileList.map(({ id: value, name: label, color }) => ({
      value,
      label,
      color,
    }))
  }, [access.lmsProfiles, hasProfilesLimited, lmsProfileList])

  return {
    profiles,
    hasProfilesLimited,
  }
}
